/**
 * URL contract ของหน้าเต็มใบตามเก็บอุปกรณ์ / ใบแจ้งยกเลิก (มติ PO 28 ต.ค. 2026 — แทนโมดัลดูทั้งเรคคอร์ด)
 *   /rentals/equipment-returns                     รายการ (ทีละชิ้น)
 *   /rentals/equipment-returns/:requestId          ใบตามเก็บ 1 ใบ + ทุกรายการของใบ (equipment_returns.view)
 *   /rentals/equipment-returns/:requestId?item=ID  …เลื่อนไป/ไฮไลต์รายการนั้น
 *   /rentals/equipment-returns/items/:itemId       ลิงก์ราย "ชิ้น" → เด้งไปใบของมันพร้อม ?item=
 *   /rentals/cancellation-tracking                 รายการใบแจ้งยกเลิก
 *   /rentals/cancellation-tracking/:noticeId       ใบแจ้งยกเลิก 1 ใบ (rentals.view)
 * id ไม่ถูกต้อง = หน้ารายการ (ไม่สร้าง /x/NaN)
 */
export const EQUIPMENT_RETURNS_PATH = '/rentals/equipment-returns';
export const CANCELLATION_TRACKING_PATH = '/rentals/cancellation-tracking';

const toPositiveInt = (value: unknown): number | null => {
  if (value === null || value === undefined || value === '') return null;
  const n = Number(value);
  return Number.isInteger(n) && n > 0 ? n : null;
};

export function returnRequestUrl(requestId: unknown, itemId?: unknown): string {
  const id = toPositiveInt(requestId);
  if (!id) return EQUIPMENT_RETURNS_PATH;
  const item = toPositiveInt(itemId);
  return item ? `${EQUIPMENT_RETURNS_PATH}/${id}?item=${item}` : `${EQUIPMENT_RETURNS_PATH}/${id}`;
}

export function returnItemUrl(itemId: unknown): string {
  const id = toPositiveInt(itemId);
  return id ? `${EQUIPMENT_RETURNS_PATH}/items/${id}` : EQUIPMENT_RETURNS_PATH;
}

export type CancellationIntent = 'retain' | 'cancel';

export function cancellationNoticeUrl(noticeId: unknown, intent?: CancellationIntent | null): string {
  const id = toPositiveInt(noticeId);
  if (!id) return CANCELLATION_TRACKING_PATH;
  return intent ? `${CANCELLATION_TRACKING_PATH}/${id}?intent=${intent}` : `${CANCELLATION_TRACKING_PATH}/${id}`;
}

/** DOM id ของการ์ดรายการบนหน้าใบ (ใช้เลื่อนไปหา ?item=) */
export const returnItemAnchorId = (itemId: number) => `return-item-${itemId}`;
